const _ = require("lodash");
const Font = require("../util/Font");

const {
	drawArrowHead,
	drawArrow,
	calculateArrowHeadPositions,
} = require("../util/ArrowDraw");
const {getLineWidth, getDigitWidth} = require("./util/RenderHelpers");

module.exports = {
	arrow: {
		draw(rc, x, y, node, measure) {
			const {fontInfo, width} = measure;
			const dir = node.direction;

			const padding = width / 4;
			const arrowLength = width - padding;
			let x1 = x + measure.width / 2;
			let x2 = x + measure.width / 2;
			let y1 = y;
			let y2 = y;
			if (dir === "left") {
				x1 = x + padding / 2 + arrowLength;
				x2 = x + padding / 2;
			} else if (dir === "right") {
				x1 = x + padding / 2;
				x2 = x + padding / 2 + arrowLength;
			} else if (dir === "up") {
				y1 = y + arrowLength / 2;
				y2 = y - arrowLength / 2;
			} else {
				// down
				y1 = y - arrowLength / 2;
				y2 = y + arrowLength / 2;
			}
			drawArrow(rc.context, {
				x1,
				y1,
				x2,
				y2,
				headLength: arrowLength / 3,
				headHeight: arrowLength / 4,
				headCurved: true,
				lineWidth: getLineWidth(rc, fontInfo),
			});
		},
		measure(rc, fontInfo, props, node) {
			const arrowSize = fontInfo.size * 1.5;
			const isVertical = node.direction === "up" || node.direction === "down";
			const height = isVertical ? arrowSize : fontInfo.size;
			return {
				width: arrowSize,
				top: height / 2,
				bottom: height / 2,
				fontInfo,
			};
		},
	},
	linearrow: {
		draw(rc, x, y, node, measure) {
			const context = rc.context;
			const {size} = measure;
			context.save();
			context.translate(x + size / 2, y);
			const rotMap = {u: 3, r: 0, d: 1, l: 2};
			context.rotate((rotMap[node.direction] * Math.PI) / 2);
			const w = (size * 2) / 3;
			const h = size;
			const t = (w * 4) / 10;
			context
				.bp()
				.M((-1 * w) / 2, (-1 * h) / 2)
				.l(t, 0)
				.l(w - t, h / 2)
				.l(-1 * (w - t), h / 2)
				.l(-1 * t, 0)
				.l(w - t, (-1 * h) / 2)
				.z()
				.fill();
			context.restore();
		},
		measure(rc, fontInfo, props, node) {
			const size = fontInfo.size;
			return {
				size,
				width: size,
				top: size / 2,
				bottom: size / 2,
				fontInfo,
			};
		},
	},
	dayArrowSequence: {
		draw(rc, x, y, node, measure) {
			const context = rc.context;
			const {
				fontInfo,
				top,
				maxLabelHeight,
				hasLabels,
				splitLabelInfo,
				labelMeasures,
				multiplierMeasure,
				dayMeasures,
				dayPadding,
				maxDayHeight,
				arrowWidth,
				arrowHeight,
				arrowPadding,
			} = measure;
			context.save();
			context.lineWidth = 1.5 * getLineWidth(rc, fontInfo);
			//Drawing the days and their shaded rectangles
			const currY = y - top;
			const labelY = currY + maxLabelHeight / 2;
			const dayY = currY + maxLabelHeight + maxDayHeight / 2;
			let dayX = x;
			for (let i = 0; i < node.children[1].children.length; i++) {
				//Drawing the label if there is one
				if (hasLabels) {
					if (splitLabelInfo) {
						const labelInfo = splitLabelInfo;
						//Drawing the two lines of labels
						const topLabelY = labelY - labelInfo.maxTopLabelHeight / 2;
						const bottomLabelY = labelY + labelInfo.maxBottomLabelHeight / 2;
						rc.drawNode(
							rc,
							dayX +
								(dayMeasures[i].width +
									2 * dayPadding -
									labelInfo.topLabelMeasures[i].width) /
									2,
							topLabelY,
							labelInfo.topLabels[i]
						);
						rc.drawNode(
							rc,
							dayX +
								(dayMeasures[i].width +
									2 * dayPadding -
									labelInfo.bottomLabelMeasures[i].width) /
									2,
							bottomLabelY,
							labelInfo.bottomLabels[i]
						);
						//{topLabels, topLabelMeasures, bottomLabels, bottomLabelMeasures, maxTopLabelHeight, maxBottomLabelHeight};
					} else {
						//Drawing the label
						rc.drawNode(
							rc,
							dayX +
								(dayMeasures[i].width +
									2 * dayPadding -
									labelMeasures[i].width) /
									2,
							labelY,
							node.children[2].children[i]
						);
					}

					//Drawing the line along the top of the day
					context
						.sv()
						.bp()
						.M(dayX, dayY - maxDayHeight / 2)
						.L(
							dayX + dayMeasures[i].width + 2 * dayPadding,
							dayY - maxDayHeight / 2
						)
						.stroke()
						.rs();
				}

				//Drawing the highlighting and day
				context
					.sv()
					.bp()
					.rect(
						dayX,
						dayY - maxDayHeight / 2,
						dayMeasures[i].width + 2 * dayPadding,
						maxDayHeight
					)
					.fill("rgba(0,0,0,0.2")
					.rs();
				rc.drawNode(rc, dayX + dayPadding, dayY, node.children[1].children[i]);
				dayX += dayMeasures[i].width + dayPadding * 3;
				if (i < node.children[1].children.length - 1) {
					//Drawing the arrow
					const arrowX = dayX - dayPadding / 2 - arrowWidth / 2;
					const arrowY = dayY + maxDayHeight / 2 + arrowPadding;

					//drawing the arrow's tail
					context.beginPath();
					context.moveTo(arrowX, arrowY);
					context.quadraticCurveTo(
						arrowX + arrowWidth / 2,
						arrowY + (arrowHeight * 3) / 2,
						arrowX + arrowWidth,
						arrowY
					);
					context.stroke();

					//drawing the arrow's head
					const headLength = (arrowHeight * 3) / 8;
					const headHeight = (headLength * 2) / 3;
					const arrowPositions = calculateArrowHeadPositions({
						startX: arrowX + arrowWidth / 2,
						endX: arrowX + arrowWidth,
						startY: arrowY + (arrowHeight * 3) / 2,
						endY: arrowY,
						headLength: headLength,
						headHeight: headHeight,
					});
					drawArrowHead(context, _.extend(arrowPositions, {curved: true}));

					//Drawing the multiplier
					const multiplierX =
						dayX - dayPadding / 2 - multiplierMeasure.width / 2;
					const multiplierY = arrowY + arrowHeight + multiplierMeasure.top;
					rc.drawNode(rc, multiplierX, multiplierY, node.children[0]);
				}
			}
			//TODO

			context.restore();
		},
		measure(rc, fontInfo, props, node) {
			let fullWidth = 0;
			let maxDayHeight = 0;
			let minDayWidth = false;
			const dayPadding = (fontInfo.size * 2) / 3;
			const dayMeasures = [];
			let maxLabelHeight = 0;
			const labelMeasures = [];
			const hasLabels = !!node.children[2].children.length;
			let splitLabels = false;
			for (let i = 0; i < node.children[1].children.length; i++) {
				const dayMeasure = rc.measureNode(
					rc,
					fontInfo,
					props,
					node.children[1].children[i]
				);
				dayMeasures.push(dayMeasure);
				maxDayHeight = Math.max(
					maxDayHeight,
					dayMeasure.top + dayMeasure.bottom + dayPadding
				);
				const fullDayWidth = dayMeasure.width + 3 * dayPadding;
				fullWidth += fullDayWidth;
				minDayWidth = Math.min(minDayWidth || fullDayWidth, fullDayWidth);
				if (hasLabels) {
					const labelMeasure = rc.measureNode(
						rc,
						fontInfo,
						props,
						node.children[2].children[i]
					);
					if (labelMeasure.width > dayMeasure.width + 2 * dayPadding) {
						splitLabels = true;
					}
					labelMeasures.push(labelMeasure);
					maxLabelHeight = Math.max(
						maxLabelHeight,
						labelMeasure.top + labelMeasure.bottom + dayPadding
					);
				}
			}
			let splitLabelInfo = false;
			if (splitLabels) {
				//Labels are too large to fit above the days, split based on the first space node into 2 lines
				const topLabels = node.children[2].children.map(labelNode => ({
					type: "nonmath",
					children: labelNode.children.slice(
						0,
						_.findIndex(labelNode.children, n => n.type === "space")
					),
				}));
				const topLabelMeasures = topLabels.map(l =>
					rc.measureNode(rc, fontInfo, props, l)
				);
				const bottomLabels = node.children[2].children.map(labelNode => ({
					type: "nonmath",
					children: labelNode.children.slice(
						_.findIndex(labelNode.children, n => n.type === "space")
					),
				}));
				const bottomLabelMeasures = bottomLabels.map(l =>
					rc.measureNode(rc, fontInfo, props, l)
				);
				const maxTopLabelHeight = topLabelMeasures
					.map(m => m.top + m.bottom + dayPadding / 2)
					.reduce((a, b) => Math.max(a, b));
				const maxBottomLabelHeight = bottomLabelMeasures
					.map(m => m.top + m.bottom + dayPadding / 2)
					.reduce((a, b) => Math.max(a, b));
				maxLabelHeight = maxTopLabelHeight + maxBottomLabelHeight;
				splitLabelInfo = {
					topLabels,
					topLabelMeasures,
					bottomLabels,
					bottomLabelMeasures,
					maxTopLabelHeight,
					maxBottomLabelHeight,
				};
			}

			fullWidth -= dayPadding;
			const arrowPadding = dayPadding / 5;
			const arrowHeight = (maxDayHeight * 2) / 3;
			const arrowWidth = minDayWidth * 0.95;
			const multiplierMeasure = rc.measureNode(
				rc,
				fontInfo,
				props,
				node.children[0]
			);
			const fullHeight =
				maxLabelHeight +
				maxDayHeight +
				arrowHeight +
				arrowPadding +
				multiplierMeasure.top +
				multiplierMeasure.bottom;
			return {
				width: fullWidth,
				top: fullHeight / 2,
				bottom: fullHeight / 2,
				fontInfo,
				dayMeasures,
				dayPadding,
				maxDayHeight,
				hasLabels,
				labelMeasures,
				maxLabelHeight,
				splitLabelInfo,
				arrowWidth,
				arrowHeight,
				arrowPadding,
				multiplierMeasure,
			};
		},
	},
	arrowList: {
		draw(rc, x, y, node, measure) {
			const context = rc.context;
			const {
				fontInfo,
				maxListTop,
				maxListBottom,
				arrowHeight,
				arrowPadding,
			} = measure;

			context.save();
			context.lineWidth = getLineWidth(rc, fontInfo);
			//drawing the terms of the list of batex
			rc.drawNode(rc, x, y, node.children[0]);

			//drawing each of the arrows
			const aboveY = y - maxListTop - arrowPadding;
			const belowY = y + maxListBottom + arrowPadding;
			for (let i = 0; i < node.arrowInfo.length; i++) {
				const arrow = node.arrowInfo[i];
				//drawing the arrow's tail
				context.beginPath();
				const startX = x + arrow.startOffset;
				const bounceX = x + arrow.bounceOffset;
				const endX = x + arrow.endOffset;
				let arrowY = aboveY;
				if (arrow.below) {
					arrowY = belowY;
				}

				context.moveTo(startX, arrowY);
				if (_.isFinite(bounceX)) {
					context.quadraticCurveTo(
						(startX + bounceX) / 2,
						arrowY + (arrow.below ? 1 : -1) * arrow.height * 2,
						bounceX,
						arrowY
					);

					context.quadraticCurveTo(
						(bounceX + endX) / 2,
						arrowY + (arrow.below ? 1 : -1) * arrow.height * 2,
						endX,
						arrowY
					);
				} else {
					context.quadraticCurveTo(
						(startX + endX) / 2,
						arrowY + (arrow.below ? 1 : -1) * arrow.height * 2,
						endX,
						arrowY
					);
				}
				context.stroke();

				//drawing the arrow's head
				if (arrow.head !== "none") {
					const headLength = (arrowHeight * 2) / 3;
					const headHeight = (headLength * 2) / 3;
					const arrowPositionInfo = {
						startX: ((_.isFinite(bounceX) ? bounceX : startX) + endX) / 2,
						endX: endX,
						startY: arrowY + (arrow.below ? 1 : -1) * arrow.height * 2,
						endY: arrowY,
						headLength: headLength,
						headHeight: headHeight,
						curved: true,
					};
					drawArrowHead(
						context,
						calculateArrowHeadPositions(arrowPositionInfo)
					);
					if (arrow.head === "both") {
						drawArrowHead(
							context,
							calculateArrowHeadPositions(
								_.extend(arrowPositionInfo, {endX: startX})
							)
						);
					}
				}

				//drawing that arrow's label, if it has one
				if (arrow.labelNode) {
					const labelY =
						arrowY +
						(arrow.below ? 1 : -1) * (arrow.height + arrowPadding) +
						(arrow.below
							? arrow.labelMeasure.top
							: -1 * arrow.labelMeasure.bottom);
					rc.drawNode(
						rc,
						(startX + endX) / 2 - arrow.labelMeasure.width / 2,
						labelY,
						arrow.labelNode
					);
				}
			}

			context.restore();
		},
		measure(rc, fontInfo, props, node) {
			const listSizes = [];
			const arrowLocations = [0];
			let maxBottom = 0;
			let maxTop = 0;
			let width = 0;
			let i;
			rc.measureNode(rc, fontInfo, props, node.children[0]);
			for (i = 0; i < node.children[0].children.length; i++) {
				listSizes[i] = rc.measureNode(
					rc,
					fontInfo,
					props,
					node.children[0].children[i]
				);
				if (listSizes[i].top > maxTop) {
					maxTop = listSizes[i].top;
				}
				if (listSizes[i].bottom > maxBottom) {
					maxBottom = listSizes[i].bottom;
				}
				width += listSizes[i].width;
				arrowLocations[i + 1] =
					arrowLocations[i] +
					(i - 1 >= 0 ? listSizes[i - 1].width / 2 : 0) +
					listSizes[i].width / 2;
			}

			const arrowHeight = getDigitWidth(rc, fontInfo);
			const lineWidth = getLineWidth(rc, fontInfo);
			const arrowPadding = 2 * lineWidth;

			const labelRatio = 0.7;
			const labelFontInfo = _.extend({}, fontInfo, {
				size: fontInfo.size * labelRatio,
			});
			let aboveMaxArrowLabelHeight = 0;
			let belowMaxArrowLabelHeight = 0;
			for (i = 0; i < node.arrowInfo.length; i++) {
				const arrow = node.arrowInfo[i];
				arrow.height = (arrow.size || 1) * arrowHeight;
				let fullHeight = arrowPadding + arrow.height;
				if (arrow.labelNode) {
					arrow.labelMeasure = rc.measureNode(
						rc,
						labelFontInfo,
						props,
						arrow.labelNode
					);
					fullHeight +=
						arrowPadding + arrow.labelMeasure.top + arrow.labelMeasure.bottom;
				}
				if (arrow.below) {
					belowMaxArrowLabelHeight = Math.max(
						belowMaxArrowLabelHeight,
						fullHeight
					);
				} else {
					aboveMaxArrowLabelHeight = Math.max(
						aboveMaxArrowLabelHeight,
						fullHeight
					);
				}
				arrow.startOffset = arrowLocations[arrow.start];
				arrow.bounceOffset = arrow.bounce && arrowLocations[arrow.bounce];
				arrow.endOffset = arrowLocations[arrow.end];

				arrow.startOffset += (arrow.start < arrow.end ? 1 : -1) * 2 * lineWidth;
				if (_.isFinite(arrow.bounceOffset))
					arrow.bounceOffset +=
						(arrow.start < arrow.bounce ? -1 : 1) * 2 * lineWidth;
				arrow.endOffset += (arrow.start < arrow.end ? -1 : 1) * 2 * lineWidth;
			}
			const totalTop = maxTop + aboveMaxArrowLabelHeight;
			const totalBottom = maxBottom + belowMaxArrowLabelHeight;

			return {
				width,
				top: totalTop,
				bottom: totalBottom,
				fontInfo,
				listSizes,
				labelRatio,
				maxListTop: maxTop,
				maxListBottom: maxBottom,
				arrowHeight,
				arrowPadding,
			};
		},
	},
	equalArrows: {
		draw(rc, x, y, node, measure) {
			const context = rc.context;
			const {
				fontInfo,
				fracSizes,
				equalWidth,
				labelRatio,
				labelSize,
				maxFracTop,
				maxFracBottom,
				arrowHeight,
			} = measure;
			const lineWidth = getLineWidth(rc, fontInfo);

			const leftX = x + fracSizes[0].width;
			const rightX = leftX + equalWidth;

			context.save();
			context.font = Font.fromInfo(fontInfo);
			context.lineWidth = lineWidth;
			rc.drawNode(rc, x, y, node.children[0]);
			rc.drawNode(rc, leftX, y, node.children[3]);
			rc.drawNode(rc, rightX, y, node.children[1]);

			//drawing the labels
			context.save();
			const labelFontInfo = _.extend({}, fontInfo, {
				size: fontInfo.size * labelRatio,
			});
			const labelX = (leftX + rightX) / 2 - labelSize.width / 2;
			const labelTopY = y - maxFracTop - arrowHeight - labelSize.bottom;
			const labelBottomY = y + maxFracBottom + arrowHeight + labelSize.top;
			context.fontInfo = Font.fromInfo(labelFontInfo);
			rc.drawNode(rc, labelX, labelTopY, node.children[2]);
			rc.drawNode(rc, labelX, labelBottomY, node.children[2]);
			context.restore();

			//drawing the arrows

			//drawing the arrow's tails
			context.beginPath();
			context.moveTo(leftX, y - maxFracTop);
			context.quadraticCurveTo(
				(leftX + rightX) / 2,
				labelTopY,
				rightX,
				y - maxFracTop
			);
			context.moveTo(leftX, y + maxFracBottom);
			context.quadraticCurveTo(
				(leftX + rightX) / 2,
				labelBottomY,
				rightX,
				y + maxFracBottom
			);
			context.stroke();

			//drawing the arrow's head
			const headLength = arrowHeight / 2;
			const headHeight = (headLength * 2) / 3;
			const arrowInfo = {
				startX: (leftX + rightX) / 2,
				endX: node.direction === "right" ? rightX : leftX,
				startY: (y - maxFracTop - arrowHeight + labelTopY) / 2,
				endY: y - maxFracTop,
				headLength: headLength,
				headHeight: headHeight,
				curved: true,
			};
			let arrowPositions = calculateArrowHeadPositions(arrowInfo);
			drawArrowHead(context, arrowPositions);
			arrowInfo.startY = (y + maxFracBottom + arrowHeight + labelBottomY) / 2;
			arrowInfo.endY = y + maxFracBottom;
			arrowPositions = calculateArrowHeadPositions(arrowInfo);
			drawArrowHead(context, arrowPositions);

			context.restore();
		},
		measure(rc, fontInfo, props, node) {
			//measuring the fractions and equals
			const fracSizes = [];
			for (let i = 0; i < 2; i++) {
				fracSizes[i] = rc.measureNode(rc, fontInfo, props, node.children[i]);
			}
			const maxTop = Math.max(fracSizes[0].top, fracSizes[1].top);
			const maxBottom = Math.max(fracSizes[0].bottom, fracSizes[1].bottom);
			let width = fracSizes[0].width + fracSizes[1].width;
			const equalWidth = rc.measureNode(rc, fontInfo, props, node.children[3])
				.width;
			width += equalWidth;
			//measuring the arrows and label
			const labelRatio = 0.7;
			const labelFontInfo = _.extend({}, fontInfo, {
				size: fontInfo.size * labelRatio,
			});
			const labelSize = rc.measureNode(
				rc,
				labelFontInfo,
				props,
				node.children[2]
			);

			const arrowHeight = getDigitWidth(rc, fontInfo);
			const totalTop = maxTop + arrowHeight + labelSize.top + labelSize.bottom;
			const totalBottom =
				maxBottom + arrowHeight + labelSize.top + labelSize.bottom;
			return {
				width,
				top: totalTop,
				bottom: totalBottom,
				fontInfo,
				fracSizes,
				equalWidth,
				maxFracTop: maxTop,
				maxFracBottom: maxBottom,
				labelRatio,
				labelSize,
				arrowHeight,
			};
		},
	},
	distributionArrows: {
		draw(rc, x, y, node, measure) {
			const context = rc.context;
			const {
				fontInfo,
				distMeasure,
				positionXOffsets,
				arrowPadding,
				arrowHeight,
			} = measure;
			context.save();
			context.lineWidth = getLineWidth(rc, fontInfo);

			//Drawing the distribution math
			rc.drawNode(rc, x, y, node.children[0]);
			//Then drawing the arrows
			const topArrowY = y - distMeasure.top - arrowPadding;
			const bottomArrowY = y + distMeasure.bottom + arrowPadding;
			const headLength = arrowHeight / 3;
			const headHeight = (headLength * 2) / 3;
			_.forEach(node.arrowPositions, aInfo => {
				const startX = x + positionXOffsets[aInfo.start];
				const endX = x + positionXOffsets[aInfo.end];
				const midX = (startX + endX) / 2;
				const height = arrowHeight * (aInfo.doubleHeight ? 2 : 1);
				const startY = aInfo.isBelow ? bottomArrowY : topArrowY;
				const curveY = aInfo.isBelow ? startY + height : startY - height;
				context
					.bp()
					.M(startX, startY)
					.Q(midX, curveY, endX, startY)
					.stroke();
				const arrowHeadPosition = calculateArrowHeadPositions({
					startX: midX,
					endX: endX,
					startY: curveY,
					endY: startY,
					headLength,
					headHeight,
					curved: true,
				});
				drawArrowHead(context, arrowHeadPosition);
			});
			context.restore();
		},
		measure(rc, fontInfo, props, node) {
			const distMeasure = rc.measureNode(rc, fontInfo, props, node.children[0]);
			const arrowHeight = getDigitWidth(rc, fontInfo) * 2;

			const positionXOffsets = _.fill(
				new Array(node.children[0].children.length),
				0
			);
			const childMeasures = _.map(node.children[0].children, c =>
				rc.getMeasure(c)
			);
			for (let i = 0; i < node.children[0].children.length; i++) {
				positionXOffsets[i] += childMeasures[i].width / 2;
				if (i > 0) {
					positionXOffsets[i] +=
						positionXOffsets[i - 1] + childMeasures[i - 1].width / 2;
				}
			}
			const lineWidth = getLineWidth(rc, fontInfo);
			const arrowPadding = 2 * lineWidth;
			const top = distMeasure.top + arrowHeight + arrowPadding;
			const hasBottomArrows = _.find(node.arrowPositions, a => a.isBelow);
			const bottom =
				distMeasure.bottom + (hasBottomArrows ? arrowHeight + arrowPadding : 0);
			return {
				width: distMeasure.width,
				top: top,
				bottom: bottom,
				fontInfo,
				distMeasure,
				arrowHeight,
				arrowPadding,
				positionXOffsets,
			};
		},
	},
};
